import React from "react";
import { calculateDisplayedPrice } from "../../utils/calculateDisplayedPrice";

export default function SummaryChildNoDiscount(props) {
  // PROPS COMING FROM SummaryBeforeAddToCart
  const { normalisedQty, price } = props;

  return (
    <>
      {normalisedQty > 0 && (
        <table style={{ width: "95%", marginTop: "1rem", fontSize: "1rem" }}>
          <thead>
            <tr
              style={{
                backgroundColor: "lightgrey",
              }}
            >
              <th
                style={{
                  border: "3px solid white",
                  alignItems: "center",
                }}
              >
                <p className="padq txtcenter">Sepet Öncesi Özet</p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              style={{
                borderBottom: "3px solid white",
              }}
            >
              <td className="row">
                <p className="lh1-5 ">
                  {normalisedQty}
                  <span className="fs-65 marq">X</span>
                  {calculateDisplayedPrice(price.price)}
                </p>
                <p>{calculateDisplayedPrice(price.price, normalisedQty)} TL</p>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr
              style={{
                borderBottom: "3px solid white",
              }}
            >
              <th className="row">
                <p className="lh1-5 txtmid">Toplam Tutar</p>

                <p>{calculateDisplayedPrice(price.price, normalisedQty)} TL</p>
              </th>
            </tr>
            <tr
              style={{
                backgroundColor: "lightgrey",
              }}
            >
              <th
                style={{
                  border: "3px solid white",
                  alignItems: "center",
                }}
                colSpan="5"
              >
                <ul className="padq txtleft lh1-5">
                  <li className="beddo-border-bottom-light">
                    <i className="fas fa-square beddo-color fs-65 marq"></i>
                    Sevdikleriniz için adet artırın.
                  </li>
                  <li className="beddo-border-bottom-light">
                    <i className="fas fa-square beddo-color fs-65 marq"></i>
                    Farklı mekanlar için adet artırın.(Ev, ofis, vb.)
                  </li>
                </ul>
              </th>
            </tr>
          </tfoot>
        </table>
      )}
    </>
  );
}
